<ion-header style="background: #fff" class="ion-no-border">
  <ion-toolbar class="Recovery-trac-header Recovery-trac-header1">
    <ion-title>{{ title }}</ion-title>
    <span (click)="onClose()" class="close_icon">
      <ion-icon size="large" name="close-outline"></ion-icon>
    </span>
  </ion-toolbar>
</ion-header>
